
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-64870691\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!./modalCardAlert.scss")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./modalCardAlert.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-64870691\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./modalCardAlert.vue.html"),
  /* scopeId */
  "data-v-64870691",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/home/modals/modalCardAlert/modalCardAlert.vue.html
// module id = ldv/
// module chunks = 2